import { useEffect } from 'react'
import { useNotifications } from '@/components'

export function GlobalErrorListener() {
  const { notify } = useNotifications()

  useEffect(() => {
    const handleError = () => {
      notify({
        title: 'Erro inesperado',
        message: 'Não foi possível concluir a ação. Seus dados locais não foram enviados.',
        tone: 'error',
      })
    }

    const handleRejection = () => {
      notify({
        title: 'Operação interrompida',
        message: 'Tente novamente. Se o problema persistir, reinicie o aplicativo.',
        tone: 'error',
      })
    }

    window.addEventListener('error', handleError)
    window.addEventListener('unhandledrejection', handleRejection)

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handleRejection)
    }
  }, [notify])

  return null
}
